import { useEffect, useState } from 'react'
import { getAttachments } from '../api'
import { toast } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { IGetAttachmentsRequest } from '../typings'

export const useGetAttachmentsOnMount = (
  oppLeadId: number,
  isLeadAttached: boolean,
) => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const getAttachmentsRequest: IGetAttachmentsRequest = {
          assignToEntity: oppLeadId,
          isLeadAttached: isLeadAttached,
        }
        const result = await dispatch(getAttachments(getAttachmentsRequest))

        if (mounted) {
          if (getAttachments.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
            toast.error('Error loading attachments.')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, isLeadAttached, oppLeadId])

  return status
}
